var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rootView homeView"},[_c('div',{staticClass:"indexView",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"leftView"},[_c('LeftMenu')],1),_c('div',{staticClass:"rightView"},[_c('TopMenu'),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.key})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }